module.exports = __webpack_public_path__ + "static/media/u2705.8ac9da23.png";